import { makeStyles } from 'tss-react/mui';

const useStylesUploadFileButton: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  uploadFileButtonContainerPreviewImage: {
    margin: 20,
    '&:hover': {
      opacity: 0.9,
    },
    '& > div': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: 0,
      '&:hover': {
        background: theme.palette.background.default,
        cursor: 'pointer',
        opacity: 0.5,
      },
      [theme.breakpoints.down('md')]: {
        background: 'none !important',
        opacity: 1,
        '& > svg': {
          top: -5,
          right: -5,
          [theme.breakpoints.down('md')]: {
            top: -2,
            right: -18,
          },
        },
      },
    },
  },
  uploadFileButtonContainerPreviewImageNoOffset: {
    margin: 0,
  },
  uploadFileButtonIconPreviewImageDelete: {
    position: 'absolute',
    right: 3,
    width: '15px !important',
    height: '15px !important',
    color: theme.palette.common.black,
    zIndex: 18,
    [theme.breakpoints.down('md')]: {
      width: 20,
      height: 20,
    },
    '&:hover': {
      cursor: 'pointer',
      opacity: 0.5,
    },
  },
  uploadFileButton: {
    padding: '10px !important',
    color: `${theme.palette.secondary.main} !important`,
  },
  uploadFileButtonNoPadding: {
    padding: '0 !important',
  },
  uploadFileButtonDisabled: {
    color: `${theme.palette.action.disabled} !important`,
  },
  uploadFileButtonImage: {
    height: '100%',
  },
  uploadFileButtonPreviewImage: {
    maxWidth: 60,
    maxHeight: 60,
  },
}));

export default useStylesUploadFileButton;
